import { RefObject, useEffect } from "react";

/**
 * Hook that execute callback when clicks outside of the passed ref
 */

export const useClickOutside = (ref: RefObject<HTMLElement | null>, callBack: () => void, enabled: boolean = true) => {
  useEffect(() => {
    if (!enabled){
      return;
    }

    function handleClickOutside(event: MouseEvent) {
      const target = event.target as Node

      // from usehooks-ts
      // Do nothing if the target is not connected element with document
      if (!target || !target.isConnected) {
        return
      }

      const isOutside = Array.isArray(ref)
        ? ref
          .filter(r => Boolean(r.current))
          .every(r => r.current && !r.current.contains(target))
        : ref.current && !ref.current.contains(target)

      if (isOutside) {
        callBack()
      }
    }
    // Bind the event listener
    document.addEventListener("click", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("click", handleClickOutside);
    };
  }, [enabled, callBack, ref]);
}